import React from "react";
import { useParams, Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import SuiviIAComponent from "../components/SuiviIAComponent";

// Cette page encapsule le composant SuiviIAComponent dans la structure de pages existante

const SuiviIAPage = () => {
  const { artworkId } = useParams();
  const { t } = useTranslation();

  return (
    <div className="max-w-6xl mx-auto pb-16">
      {/* En-tête avec bouton retour */}
      <div className="py-4 px-6 border-b border-gray-200">
        <div className="flex items-center">
          <Link to={`/artwork/${artworkId}`} className="flex items-center text-gray-600 hover:text-gray-900">
            <FiArrowLeft className="h-5 w-5 mr-2" />
            <span>{t("suiviIAPage.backToArtwork")}</span>
          </Link>
        </div>
      </div>

      {/* Composant principal de suivi IA */}
      <SuiviIAComponent />
    </div>
  );
};

export default SuiviIAPage;